<template>
  <v-dialog v-model="visible" persistent max-width="400">
    <v-card>
      <v-card-title class="headline">{{ i18n.factoryStaffConfirmTitle }}</v-card-title>
      <v-card-text>{{ i18n.factoryStaffConfirmMessage }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="onNo">{{ i18n.factoryStaffNo }}</v-btn>
        <v-btn color="primary" text @click="onYes">{{ i18n.factoryStaffYes }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import router from '@/router';

export default {
  name: 'FactoryStaffConfirmModal',
  computed: {
    ...mapState({
      visible: 'factoryStaffDialogVisible',
      locale: 'locale',
    }),
    i18n() {
      return this.$store.state[this.$store.state.locale];
    },
  },
  methods: {
    ...mapMutations({
      setFactoryStaffDialogVisible: 'setFactoryStaffDialogVisible',
      setFactoryStaffConfirmed: 'setFactoryStaffConfirmed',
    }),
    onYes() {
      this.setFactoryStaffDialogVisible(false);
      this.setFactoryStaffConfirmed(true);
    },
    onNo() {
      this.setFactoryStaffDialogVisible(false);
      router.push({ path: '/factory-only' });
    },
  },
};
</script>
